export class _BaseModel {
    static collectionName = '';
}